<div class="main-header">
    <div class="logo">
        <img src="../../../../../../assets/images/WORKQUA-Logo2-02.png" alt="">
    </div>

    <div class="menu-toggle me-0" (click)="toggelSidebar()">
        <div></div>
        <div></div>
        <div></div>
    </div>

    <!-- <div class="d-flex align-items-center">
        <div ngbDropdown class="mega-menu d-none d-md-block">
            <button ngbDropdownToggle href="#" class="btn text-muted dropdown-toggle me-3">Mega Menu</button>
            <div ngbDropdownMenu>
                <div class="row m-0">
                    <div class="col-md-4 p-4 bg-img">
                        <h2 class="title">Mega Menu <br> Sidebar</h2>
                        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Asperiores natus
                            laboriosam fugit, consequatur.
                        </p>
                        <p class="mb-4">Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                            Exercitationem odio amet eos dolore suscipit placeat.</p>
                        <button class="btn btn-lg btn-rounded btn-outline-warning">Learn More</button>
                    </div>
                    <div class="col-md-4 p-4">
                        <p class="text-primary text--cap border-bottom-primary d-inline-block">Features</p>
                        <div class="menu-icon-grid w-auto p-0">
                            <a href="#"><i class="i-Shop-4"></i> Home</a>
                            <a href="#"><i class="i-Library"></i> UI Kits</a>
                            <a href="#"><i class="i-Drop"></i> Apps</a>
                            <a href="#"><i class="i-File-Clipboard-File--Text"></i> Forms</a>
                            <a href="#"><i class="i-Checked-User"></i> Sessions</a>
                            <a href="#"><i class="i-Ambulance"></i> Support</a>
                        </div>
                    </div>
                    <div class="col-md-4 p-4">
                        <p class="text-primary text--cap border-bottom-primary d-inline-block">Components</p>
                        <ul class="links">
                            <li><a href="accordion.html">Accordion</a></li>
                            <li><a href="alerts.html">Alerts</a></li>
                            <li><a href="buttons.html">Buttons</a></li>
                            <li><a href="badges.html">Badges</a></li>
                            <li><a href="carousel.html">Carousels</a></li>
                            <li><a href="lists.html">Lists</a></li>
                            <li><a href="popover.html">Popover</a></li>
                            <li><a href="tables.html">Tables</a></li>
                            <li><a href="datatables.html">Datatables</a></li>
                            <li><a href="modals.html">Modals</a></li>
                            <li><a href="nouislider.html">Sliders</a></li>
                            <li><a href="tabs.html">Tabs</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="search-bar">
            <input type="text" placeholder="Search" (focus)="searchService.searchOpen = true">
            <i class="search-icon text-muted i-Magnifi-Glass1"></i>
        </div>
    </div> -->

    <div style="margin: auto"></div>

    <div class="header-part-right">

<!-- (change)="onSelect($event)" -->

        <!-- <div ngbDropdown>
            <a class="nav-link" ngbDropdownToggle id="languageDropdown" role="button">

                <i class="i-Globe text-muted header-icon"></i>
                <span class="fw-bold ms-1 me-1 d-none d-md-inline-block">{{selectedLanguage}}</span>
            </a>
            <div ngbDropdownMenu aria-labelledby="languageDropdown">


                <a ngbDropdownItem *ngFor="let language of languages" class="py-2" (click)="changeLanguage(language)">
                    <!-- <img [src]="language.flagPath" class="wd-20 me-1" title="{{ language.displayName }}" alt="{{ language.code }}"> -->
                    <!-- <span class="ms-1">{{ language.displayName }}</span>
                </a>

            </div>
        </div> -->
        <!-- <i class="i-Magnifi-Glass1 header-icon  d-none d-md-inline-block" role="button"
            (click)="searchService.searchOpen = true"></i> -->
        <i fullScreenWindow class="i-Full-Screen header-icon d-none d-sm-inline-block  d-none d-md-inline-block"
            role="button"></i>
        <!-- <div ngbDropdown [placement]="'bottom-right'" class="d-none d-sm-inline-block">
            <i ngbDropdownToggle class="i-Gear text-muted header-icon" role="button"></i>
            <div ngbDropdownMenu class="menu-icon-grid-dropdown">
                <div class="menu-icon-grid">
                    <a href="#"><i class="i-Shop-4"></i> Home</a>
                    <a href="#"><i class="i-Library"></i> UI Kits</a>
                    <a href="#"><i class="i-Drop"></i> Apps</a>
                    <a href="#"><i class="i-File-Clipboard-File--Text"></i> Forms</a>
                    <a href="#"><i class="i-Checked-User"></i> Sessions</a>
                    <a href="#"><i class="i-Ambulance"></i> Support</a>
                </div>
            </div>
        </div> -->




        <div *ngIf="signalRService.signalrNotifications?.length>0" ngbDropdown [placement]="'bottom-right'">

            <div class="badge-top-container">
                <span
                    class="badge p-0 position-absolute bg-danger rounded-circle d-flex justify-content-center align-items-center">{{signalRService.signalrNotifications?.length}}</span>
                <i ngbDropdownToggle class="i-Bell text-muted header-icon" role="button"></i>
            </div>

            <div ngbDropdownMenu class="notification-dropdown rtl-ps-none" perfectScrollbar>
                <div class="dropdown-item d-flex" *ngFor="let item of signalRService.signalrNotifications"
                    (click)="readNotification(item)">
                    <div class="notification-icon">
                        <i class="{{item.icon}} text-{{item.status}} mr-1"></i>
                    </div>
                    <div class="notification-details flex-grow-1">
                        <p class="m-0 d-flex align-items-center">
                            <span>{{item.title}}</span>
                            <span *ngIf="item.badge"
                                class="badge badge-pill badge-{{item.status}} ml-1 mr-1">{{item.badge}}</span>
                            <span class="flex-grow-1"></span>
                            <span class="text-small text-muted ml-auto">{{item.time | relativeTime}}</span>
                        </p>
                        <p class="text-small text-muted m-0">{{item.text | excerpt:30}}</p>
                    </div>
                </div>
            </div>
        </div>





















        <!-- <div ngbDropdown [placement]="'bottom-right'">
            <div class="badge-top-container">
                <span class="badge p-0 position-absolute bg-danger rounded-circle d-flex justify-content-center align-items-center">{{notifications?.length}}</span>
                <i ngbDropdownToggle class="i-Bell text-muted header-icon" role="button"></i>
            </div>
            <div ngbDropdownMenu class="notification-dropdown">
                <ng-scrollbar>
                    <div class="dropdown-item d-flex" *ngFor="let item of notifications" [routerLink]="[item.link]">
                        <div class="notification-icon">
                            <i class="{{item.icon}} text-{{item.status}} me-1"></i>
                        </div>
                        <div class="notification-details flex-grow-1">
                            <p class="m-0 d-flex align-items-center">
                                <span>{{item.title}}</span>
                                <span *ngIf="item.badge"
                                    class="badge badge-pill badge-{{item.status}} ms-1 me-1">{{item.badge}}</span>
                                <span class="flex-grow-1"></span>
                                <span class="text-small text-muted ms-auto">{{item.time | relativeTime}}</span>
                            </p>
                            <p class="text-small text-muted m-0">{{item.text | excerpt:30}}</p>
                        </div>
                    </div>
                </ng-scrollbar>
            </div>
        </div> -->

        <div ngbDropdown [placement]="'bottom-right'" class="user col align-self-center">
            <a class=" large-avatar-detail-page" ngbDropdownToggle id="profileDropdown" *ngIf="!loader">
                {{initials}}
            </a>

            <div ngbDropdownMenu aria-labelledby="userDropdown" class="header-account-dropdown">
                <div class="dropdown-header">
                    <i class="i-Lock-User me-1"></i> {{User?.name}}
                </div>
                <!-- <button class="dropdown-item">Account settings</button>
                <button class="dropdown-item">Billing history</button> -->
                <button class="dropdown-item" (click)="signout()">Sign out</button>
            </div>
        </div>

    </div>

</div>